'use strict';

var _debounce = require('lodash-es/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _themeSections = require('@shopify/theme-sections');

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _utils = require('../helpers/utils');

var _toggle = require('../components/toggle');

var _toggle2 = _interopRequireDefault(_toggle);

var _notification = require('../components/notification');

var _notification2 = _interopRequireDefault(_notification);

var _scrollDirection = require('../mixins/scroll-direction');

var _scrollDirection2 = _interopRequireDefault(_scrollDirection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
var selectors = {
  container: '[js-site-header="container"]',
  searchForm: '[js-toggle="searchTarget"]',
  searchInput: '[js-search="input"]',
  searchLabel: '[js-search="label"]',
  navBar: '[js-site-header="sticky"]',
  notificationBar: '.site-header__announcement'
};

/**
 * Create a new site header object.
 */
/**
 * Section: Site header
 * ------------------------------------------------------------------------------
 * Contains highly coupled scripts to control site header components
 *
 * @namespace siteHeader
 */
(0, _themeSections.register)('site-header', {

  /**
   * Callback function when the section is loaded in via the 'sections.load()' function or by Theme Editor
   * 'shopify:section:unload' event
   */
  onLoad: function onLoad() {
    this.constructComponents();
    this.init();
  },


  /**
   * Component selectors.
   */
  setNodeSelectors: function setNodeSelectors() {
    this.container = document.querySelector(selectors.container);
    this.searchForm = document.querySelector(selectors.searchForm);
    this.searchInput = this.searchForm.querySelector(selectors.searchInput);
    this.searchLabel = this.searchForm.querySelector(selectors.searchLabel);
    this.navBar = this.container.querySelector(selectors.navBar);
    this.notificationBar = document.querySelector(selectors.notificationBar);
  },


  /**
   * Instantiate search bar toggle.
   */
  constructSearchToggle: function constructSearchToggle() {
    this.SearchBar = (0, _toggle2.default)({
      toggleSelector: 'searchToggle',
      targetSelector: 'searchTarget',
      overlay: false
    });
  },


  /**
   * Instantiate announcement component.
   */
  constructAnnouncement: function constructAnnouncement() {
    this.Announcement = (0, _notification2.default)({
      container: '.site-header__announcement',
      enableCookies: true,
      cookie: {
        namespace: 'frame_announcement',
        value: 'dismissed'
      }
    });
  },


  /**
   * Instantiate a collapsed header on scroll using scrollDirection helper.
   */
  constructStickyHeader: function constructStickyHeader() {
    this.AnimatedHeader = (0, _scrollDirection2.default)({
      throttle: 250,
      start: 100
    });
  },


  /**
   * Construct section components.
   */
  constructComponents: function constructComponents() {
    this.constructSearchToggle();
    this.constructAnnouncement();
    this.constructStickyHeader();
  },


  /**
   * Initialise component.
   */
  init: function init() {
    this.setNodeSelectors();
    this.Announcement.init();
    this.setListeners();
    this.windowWidthListeners();
    this.setSearchToggle();
    this.stickyHandleCase();
  },


  /**
   * Set search toggle events.
   */
  setSearchToggle: function setSearchToggle() {
    var _this = this;

    this.SearchBar.init();
    if (this.searchInput.value.length > 0) {
      this.searchLabel.classList.add(_cssClasses2.default.hidden);
    }
    (0, _utils.on)('keyup', this.searchInput, function () {
      return _this.handleKeypressEvent();
    });
  },


  /**
   * Handle search keydown event.
   */
  handleKeypressEvent: function handleKeypressEvent() {
    if (this.searchInput.value.length > 0) {
      this.searchLabel.classList.add(_cssClasses2.default.hidden);
      return;
    }
    this.searchLabel.classList.remove(_cssClasses2.default.hidden);
  },


  /**
   * Check if screen is mobile or Desktop
   */
  windowWidthListeners: function windowWidthListeners() {
    var _this2 = this;

    (0, _utils.on)('load', function () {
      return _this2.stickyHeaderCheck();
    });
    (0, _utils.on)('resize', (0, _debounce2.default)(function () {
      return _this2.stickyHeaderCheck();
    }, 250));
  },


  /**
   * Mobile - Set sticky header events after document has loaded styling.
   */
  stickyHeaderCheck: function stickyHeaderCheck() {
    var _this3 = this;

    this.AnimatedHeader.init();
    this.updateBodyOffset();
    (0, _utils.on)('scroll', function () {
      return _this3.stickyHandleCase();
    });
  },


  /**
   * Creat or remove sticky header depending on scroll position
   */
  stickyHandleCase: function stickyHandleCase() {
    var navTop = this.navBar.offsetTop;
    var scrollHeight = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    this.updateBodyOffset();
    if (navTop > scrollHeight) {
      this.stickyHeaderRemove();
    } else {
      this.stickyHeaderSet();
    }
  },


  /**
   * Create sticky nav
   */
  stickyHeaderSet: function stickyHeaderSet() {
    var notificationBarHeight = this.getNotificationBarHeight();
    this.container.parentNode.style.top = '-' + notificationBarHeight + 'px';
    this.container.parentNode.classList.add(_cssClasses2.default.sticky);
    this.container.classList.remove(_cssClasses2.default.headerClear);
  },


  /**
   * Remove sticky header
   */
  stickyHeaderRemove: function stickyHeaderRemove() {
    this.container.parentNode.style.top = '0';
    this.container.parentNode.classList.remove(_cssClasses2.default.sticky);
  },


  /**
   * Return height of notifaction bar
   */
  getNotificationBarHeight: function getNotificationBarHeight() {
    return this.notificationBar.offsetHeight;
  },


  /**
  * Return header padding
  */
  getHeaderPadding: function getHeaderPadding() {
    if (window.theme.features.clearHeader === true) {
      return 140;
    } else {
      return this.notificationBar.offsetHeight;
    }
  },


  /**
   * Handle resize events by requesting animation frame.
   */
  handleResizeEvents: function handleResizeEvents() {
    this.updateBodyOffset();
  },


  /**
   * Re-paint body padding-top using current header height.
   */
  updateBodyOffset: function updateBodyOffset() {
    if ((0, _utils.isDesktop)()) {
      var headerHeight = this.getHeaderPadding();
      document.body.style.paddingTop = headerHeight + 'px';
    } else {
      var _headerHeight = this.container.offsetHeight;
      document.body.style.paddingTop = _headerHeight + 'px';
    }
  },


  /**
   * Set listeners based on scroll direction.
   */
  setListeners: function setListeners() {
    var _this4 = this;

    Frame.EventBus.listen('Notification:dismissed', function () {
      _this4.updateBodyOffset();
    });

    Frame.EventBus.listen('ScrollDirection:down', function () {
      if (window.theme.features.disableClearHeader === true) {
        return false;
      }
      _this4.container.parentNode.classList.add(_cssClasses2.default.collapsed);
      _this4.container.classList.remove(_cssClasses2.default.headerClear);
    });

    Frame.EventBus.listen('ScrollDirection:top', function () {
      if (window.theme.features.disableClearHeader === true) {
        return false;
      }
      _this4.container.parentNode.classList.remove(_cssClasses2.default.collapsed);
      _this4.container.classList.add(_cssClasses2.default.headerClear);
    });

    Frame.EventBus.listen('Toggle:searchTarget:open', function () {
      document.documentElement.classList.add('js-search-active');
      _this4.container.classList.remove(_cssClasses2.default.headerClear);
      window.theme.features.disableClearHeader = true;
      window.theme.features.disableMenu = true;
    });

    Frame.EventBus.listen('Toggle:searchTarget:close', function () {
      document.documentElement.classList.remove('js-search-active');
      window.theme.features.disableClearHeader = false;
      window.theme.features.disableMenu = false;
    });
  }
});